// extracted by mini-css-extract-plugin
module.exports = {"profitablityCard":"styles_profitablityCard__Trz0W","chartContainer":"styles_chartContainer__QLBLw"};